module.exports = __webpack_public_path__ + "img/unit-icon.bb92172c.png";